import React from "react";
import { baseUrl } from "../../constants";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="main-footer py-3 px-1 flex flex-col items-center justify-center space-y-2 m-0 flex-wrap text-white">
      <div className="social-handles-div w-full flex justify-evenly items-center flex-wrap">
        <a
          className="socHandel hover:text-green-200"
          target="_blank"
          href="https://www.instagram.com/hlad_nitkkr"
        >
          <img
            alt=""
            className="social-logo h-2 w-2 p-2"
            src={`/image/instagram.jpg`}
          />{" "}
          <div className="social-handle-name">Instagram</div>
        </a>
        <a
          className="socHandel hover:text-green-200"
          target="_blank"
          href="https://www.facebook.com/hladcnitkkr/"
        >
          <img
            alt=""
            className="social-logo h-2 w-2"
            src={`/image/facebook.jpg`}
          />{" "}
          <div className="social-handle-name">Facebook</div>
        </a>
        <a
          className="socHandel hover:text-green-200"
          target="_blank"
          href="https://www.youtube.com/@HLADNITKKR"
        >
          <img
            alt=""
            className="social-logo h-2 w-2"
            src={`/image/youtube.png`}
          />{" "}
          <div className="social-handle-name">Youtube</div>
        </a>
        <a
          className="socHandel hover:text-green-200"
          target="_blank"
          href="mailto:hladcontact@gmail.com"
        >
          <img
            alt=""
            className="social-logo h-2 w-2"
            src={`/image/gmail.png`}
          />{" "}
          <div className="social-handle-name">Gmail</div>
        </a>
      </div>
      <div className="text-white" style={{ color: "white" }}>
        Designed With ❤️ by HLAD Members
      </div>
    </div>
  );
};

export default Footer;
